import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import { AuthFragmentDoc } from './Auth.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteAccountMigrationMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
  newPassword: Types.Scalars['String']['input'];
}>;


export type CompleteAccountMigrationMutation = { completeAccountMigration: { authChallenge: Types.AuthChallenge, user: { id: string, firstName: string, lastName: string, email: string, permissions: Array<Types.Permission>, roles: Array<Types.Role>, status: Types.UserStatus } | null, token: { accessToken: string, expiresIn: number, refreshToken: string } | null } };


export const CompleteAccountMigrationDocument = gql`
    mutation CompleteAccountMigration($email: String!, $code: String!, $newPassword: String!) {
  completeAccountMigration(email: $email, code: $code, newPassword: $newPassword) {
    ...Auth
  }
}
    ${AuthFragmentDoc}`;
export type CompleteAccountMigrationMutationFn = Apollo.MutationFunction<CompleteAccountMigrationMutation, CompleteAccountMigrationMutationVariables>;

/**
 * __useCompleteAccountMigrationMutation__
 *
 * To run a mutation, you first call `useCompleteAccountMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAccountMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAccountMigrationMutation, { data, loading, error }] = useCompleteAccountMigrationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useCompleteAccountMigrationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAccountMigrationMutation, CompleteAccountMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAccountMigrationMutation, CompleteAccountMigrationMutationVariables>(CompleteAccountMigrationDocument, options);
      }
export type CompleteAccountMigrationMutationHookResult = ReturnType<typeof useCompleteAccountMigrationMutation>;
export type CompleteAccountMigrationMutationResult = Apollo.MutationResult<CompleteAccountMigrationMutation>;
export type CompleteAccountMigrationMutationOptions = Apollo.BaseMutationOptions<CompleteAccountMigrationMutation, CompleteAccountMigrationMutationVariables>;